import React from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import routes, { routesForAuthenticatedOnly, routesForPublic } from "../../../app/routes";
import { storeToken } from "./authHelpers";
import { config } from "../../../app/config/main";
import { AuthContext } from "@jumbo/components/JumboAuthProvider/JumboAuthContext";

const storedToken = localStorage.getItem("token");

const init = () => {
  let authUser = null;


  if (!config?.authSetting) {
    throw Error(`You are using JumboAuthProvider but you haven't setup authSetting inside /src/app/config/main.js's config object`);
  }

  if (storedToken) {
    storeToken(storedToken); // also sets axios header
  }

  return {
    authToken: storedToken ?? null,
    authUser: authUser,
    isLoading: false,
    fallbackPath: config.authSetting.fallbackPath,
  }
};

const authReducer = (state, action) => {
  switch (action.type) {
    case "set-auth-data":
      return {
        ...state,
        ...action.payload,
      };

    case "start-loading":
      return {
        ...state,
        isLoading: true,
      };

    case "stop-loading":
      return {
        ...state,
        isLoading: false,
      };
  }
};

const JumboAuthProvider = ({ children, ...restProps }) => {

  const location = useLocation();

  const [authOptions, setAuthOptions] = React.useReducer(authReducer, restProps, init);
  const [logout, setLogout] = React.useState(false);
  const navigate = useNavigate();

  const NEW_U_PAGES = [
    '/micrositeOtp',
    '/micrositeTnCRegis',
    '/micrositeKonfirmasiBelumRegis',
    '/micrositeKonfirmasiUbahPassword'
  ]

  const MFA_FLOW_PAGES = ['/mfaChoice', '/verifyMfa', '/micrositeLogin', '/micrositeLupaPassword']

  React.useEffect(() => {
    const token = localStorage.getItem('token')
    const mfaPending = localStorage.getItem('mfa_pending')
    if (token && mfaPending && !MFA_FLOW_PAGES.includes(location.pathname)) {
      navigate('/verifyMfa')
    }
  }, [location])

  React.useEffect(() => {
    if (logout) {
      setAuthOptions({
        type: "set-auth-data",
        payload: { authToken: null, authUser: null, isLoading: false }
      });
      setLogout(false);
    }
  }, [logout]);

  const setAuthToken = React.useCallback(async (token) => {
    setAuthOptions({ type: "start-loading" });
    if (!token) {
      setLogout(true);
      return;
    }

    storeToken(token);
    try {

      const authUser = await config?.authSetting?.getAuthUserService;
      if (authUser) {
        setAuthOptions({
          type: "set-auth-data",
          payload: { authToken: token, authUser: authUser, isLoading: false }
        });
        return;
      }
      setLogout(true);

    } catch (error) {
      setLogout(true);
      console.error(error);
    }
  }, []);

  //todo: maybe in next version
  const setRedirectPath = React.useCallback((redirectPath) => {
    setAuthOptions({ type: "set-redirect-path", payload: { redirectPath } });
  }, []);

  const setAuthData = React.useCallback((data) => {
    setAuthOptions({ type: "set-auth-data", payload: data });
  }, []);

  const contextValue = React.useMemo(() => {

    return {
      ...authOptions,
      setAuthData,
      setRedirectPath,
      setAuthToken,
      setAuthOptions,
    }
  }, [authOptions]);

  const isNewUserPages = (NEW_U_PAGES.indexOf(location.pathname) !== -1)

  React.useEffect(() => {
    if (location.pathname.includes("robots.txt")) {
      navigate(authOptions?.fallbackPath);
      return
    }

    if (location.pathname.includes('/micrositeLupaPassword') && !localStorage.getItem("token")) {
      return
    }

    if (localStorage.getItem('success_otp') == 0 && location.pathname == "/micrositeOtp") {
      navigate('/micrositeOtp');
      return
    }

    if (localStorage.getItem('temp_token')) {
      if (!isNewUserPages) {
        navigate(-1);
      }
      return
    }

    if (isNewUserPages) {
      navigate(-1);
    }

    const token = localStorage.getItem('token')
    if (
      (!routes.some(f => location.pathname === f.path))
    ) {
      if (token) {
        navigate('/micrositeNews');
      } else {
        navigate(authOptions?.fallbackPath);
      }
    }

    // if (isNewUserPages() && !localStorage.getItem('temp_token')) {
    //   if (token) {
    //     navigate('/micrositeNews');
    //   } else {
    //     navigate(authOptions?.fallbackPath);
    //   }
    // }


    if (['/micrositeLogin', '/micrositeLupaPassword'].includes(location.pathname)) {
      if (token) {
        navigate('/micrositeNews');
      }
    }
    if ('/' === location.pathname) {
      if (token) {
        navigate('/micrositeNews');
      } else {
        navigate(authOptions?.fallbackPath);
      }
    }

    const privatepage = [...routesForAuthenticatedOnly, ...routesForPublic].findIndex(f => f.path.toLowerCase() == location.pathname.toLowerCase())

    if (privatepage != -1) {
      if (!token) {
        navigate(authOptions?.fallbackPath);
      }
    }
  }, []);

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};

export default JumboAuthProvider;